'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _ShareInput = require('../../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _UISearchInput = require('../../input/UISearchInput');

var _UISearchInput2 = _interopRequireDefault(_UISearchInput);

var _component = require('../../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UITypeaheadSearch = _react2.default.createClass({
  displayName: 'UITypeaheadSearch',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    'aria-controls': _react.PropTypes.string,
    Input: _component2.default.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      Input: _UISearchInput2.default
    };
  },
  render: function render() {
    var _props = this.props,
        ariaControls = _props['aria-controls'],
        className = _props.className,
        Input = _props.Input,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['aria-controls', 'className', 'Input', 'style']);

    return _react2.default.createElement(
      'div',
      {
        className: (0, _classNames2.default)('private-search-control__wrapper', className),
        style: style
      },
      _react2.default.createElement(Input, _extends({
        'aria-autocomplete': 'list',
        'aria-controls': ariaControls
      }, rest))
    );
  }
});

exports.default = (0, _ShareInput2.default)(UITypeaheadSearch);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/typeahead/search/UITypeaheadSearch.js
// module id = 328
// module chunks = 3 4 5